import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const Block = styled.div``;

export const Note = styled.span`
  display: block;
  color: ${colors.darkGray};
  margin-bottom: 2px;
  ${(props) =>
    props.isClickable &&
    css`
      cursor: pointer;
    `}
  ${(props) =>
    css`
      font-size: ${props.fontSize ?? '14px'};
    `}
  & i {
    font-size: 14px;
  }
`;

export const Dropdown = styled.div`
  position: relative;
`;

export const DropdownButton = styled.button`
  background: ${colors.white};
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: ${colors.darkBlue};
  border: 1px solid ${colors.lightGray};
  border-radius: 0.2rem;
  ${(props) =>
    css`
      width: ${props.widthSize ?? '120px'};
    `}
  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

export const DropdownButtonBlue = styled.button`
  background: ${colors.darkBlue};
  color: ${colors.white};
  padding: 0.375rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border: 1px solid ${colors.darkBlue};
  border-radius: 0.2rem;
  &:hover {
    background: ${colors.hoverBlue};
    border-color: ${colors.hoverBlue};
  }
`;

export const LanguageDropdownButton = styled.button`
  padding-left: 11px;
  float: left;
  height: 38px;
  width: 100%;
  background: ${colors.white};
  color: ${colors.darkGray};
  border: 1px solid ${colors.lightGray};
  border-radius: 0.2rem;
`;

export const DropdownMenu = styled.div.attrs(() => ({
  className: `dropdown-menu dropdown-menu-right'}`,
}))`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 1rem;
  color: #373a3c;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #00000026;
  border-radius: 0.25rem;
  box-shadow: 0 6px 12px #0000002e;
  & span {
    padding: 3px 20px;
  }
`;

export const DropdownItem = styled.div`
  display: block;
  width: 100%;
  padding: 3px 20px;
  ${(props) =>
    props.noPadding &&
    css`
      padding: 0 0;
    `}
  clear: both;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.5;
  color: ${(props) => (props.selected ? colors.darkBlue : colors.darkGray)};
  text-align: inherit;
  white-space: nowrap;
  background: none;
  border: 0;
  cursor: pointer;
  &:hover {
    background-color: ${colors.lightGray};
  }
`;

export const ArrowDown = styled.i.attrs({ className: 'fa fa-caret-down' })`
  margin-left: 4px;
`;
